import axiosInstance from "api/utils/axiosInstance";
import { URLS } from "api/utils/baseUrls";
import { FieldAnalysisReportDto } from "api/dtos/FieldAnalysisReportDto";

const getReport = async ({ fieldId, cropId, isBio }) => {
  const { data } = await axiosInstance.post(
    `${URLS.externalRequests}/field-analysis/report/`,
    { fieldId, cropId, isBio }
  );
  return FieldAnalysisReportDto.fromApi(data);
};

export const fieldAnalysisApi = { fetchReport: getReport };
